export default __webpack_public_path__ + "static/1-e9d095af70bb8f4cbd18e89c123865d1.png";